import React, { Suspense, useEffect } from 'react';
import { Route, Switch, Redirect, useLocation, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { message } from 'antd';
import Auth from '../hoc/auth';
import { isSessionExpired, redirectToLogin } from '../utils/sessionGuard';
// pages for this product
import LandingPage from './views/LandingPage/LandingPage.js';
import LoginPage from './views/LoginPage/LoginPage.js';
import ResetUserPage from './views/ResetUserPage/ResetUserPage.js';
import CPPage from './views/CPPage/CPPage.js';
import NavBar from './views/NavBar/NavBar';
import Footer from './views/Footer/Footer';
import UserMgrPage from './views/UserMgrPage/UserMgrPage';
import RespondentMgrPage from './views/UserMgrPage/RespondentMgrPage';
import E3DepMgrPage from './views/UserMgrPage/E3DepMgrPage.js';
import Status360Page from './views/UserMgrPage/Status360Page';
import CorpMgrPage from './views/UserMgrPage/CorpMgrPage';
import CSVUploadPage from './views/CSVUploadPage/CSVUploadPage';
import CSVUserUploadPage from './views/CSVUserUploadPage/CSVUserUploadPage';
import ExcelUserUploadPage from './views/CSVUserUploadPage/ExcelUserUploadPage';
import ChatGptTestPage from './views/ChatGptPage/ChatGptTestPage';
import CSVUserUpdateOnlyPage from './views/CSVUserUploadPage/CSVUserUpdateOnlyPage';
import CSVUserUpdatePage from './views/CSVUserUploadPage/CSVUserUpdatePage';
import CSVUserCheckPage from './views/CSVUserUploadPage/CSVUserCheckPage';
import CSVUserMergePage from './views/CSVUserUploadPage/CSVUserMergePage';
import CSVRelationUploadPage from './views/CSVUserUploadPage/CSVRelationUploadPage';
import CSVTokenInsertPage from './views/CSVUserUploadPage/CSVTokenInsertPage';
import CSVDownloadPage from './views/CSVDownloadPage/CSVDownloadPage';
import MakeReportPage from './views/MakeReportPage/MakeReportPage';
import NewTakeSurveyPage from './views/TakeSurveyPage/NewTakeSurveyPage';
import Course90101Page from './views/TakeSurveyPage/Course90101Page';
import Course90105Page from './views/TakeSurveyPage/Course90105Page'; //人事評価力診断の新動画・新フォーマット対応20250401以降
import Course90301Page from './views/TakeSurveyPage/Course90301Page';
import Course90501Page from './views/TakeSurveyPage/Course90501Page';
import Course90502Page from './views/TakeSurveyPage/Course90502Page';
import MySurveyPage from './views/MySurveyPage/MySurveyPage';
import QuestionMgrPage from './views/QuestionMgrPage/QuestionMgrPage';
import QuestionSetMgrPage from './views/QuestionSetMgrPage/QuestionSetMgrPage';
import PdfBatchJobPage from './views/PDFDownloadPage/PdfBatchJobPage';
import PDF10010CompanyDownloadPage from './views/PDFDownloadPage/PDF10010CompanyDownloadPage';
import PDF30010DownloadPage from './views/PDFDownloadPage/PDF30010DownloadPage';
import E3OrgResultPage from './views/E3ResultPage/E3OrgResultPage';
import PDF70010DownloadPage from './views/PDFDownloadPage/PDF70010DownloadPage';
import PDF80010DownloadPage from './views/PDFDownloadPage/PDF80010DownloadPage';
import PDF40010_SSDownloadPage from './views/PDFDownloadPage/PDF40010_SSDownloadPage';
import PDF60020_SSDownloadPage from './views/PDFDownloadPage/PDF60020_SSDownloadPage';
import Excel30010DownloadPage from './views/PDFDownloadPage/Excel30010DownloadPage';
import Excel10010DownloadPage from './views/PDFDownloadPage/Excel10010DownloadPage';
import Excel30010CompareDownloadPage from './views/PDFDownloadPage/Excel30010CompareDownloadPage';
import Excel40010DownloadPage from './views/PDFDownloadPage/Excel40010DownloadPage';
import Excel60020DownloadPage from './views/PDFDownloadPage/Excel60020DownloadPage';
import Excel50020DownloadPage from './views/PDFDownloadPage/Excel50020DownloadPage';
import Excel50030DownloadPage from './views/PDFDownloadPage/Excel50030DownloadPage';
import Excel50040DownloadPage from './views/PDFDownloadPage/Excel50040DownloadPage';
import CompanySum30010Page from './views/PDFDownloadPage/CompanySum30010Page';
import CompanySum50020Page from './views/PDFDownloadPage/CompanySum50020Page';
import CompanySum50030Page from './views/PDFDownloadPage/CompanySum50030Page';
import MailTemplatePage from './views/SendMailPage/MailTemplatePage';
import MakeTemplatePage from './views/SendMailPage/MakeTemplatePage';
import CSVMailSendPage from './views/SendMailPage/CSVMailSendPage';
import CSVMailSendReservatePage from './views/SendMailPage/CSVMailSendReservatePage';
import SurveyMailSendPage from './views/SendMailPage/SurveyMailSendPage';
import MailSendReservatePage from './views/SendMailPage/MailSendReservatePage';
import MailReservateListPage from './views/SendMailPage/MailReservateListPage';
import MultiMailSendReservatePage from './views/SendMailPage/MultiMailSendReservatePage';
import GroupListPage from './views/DataMgrPage/GroupListPage';
import OrgMgrPage from './views/DataMgrPage/OrgMgrPage';
import MakeGroupPage from './views/DataMgrPage/MakeGroupPage';
import SeasonListPage from './views/DataMgrPage/SeasonListPage';
import MakeSeasonPage from './views/DataMgrPage/MakeSeasonPage';
import MakeQSetPage from './views/DataMgrPage/MakeQSetPage';
import EditQSetPage from './views/DataMgrPage/EditQSetPage';
import PublicDocMgrPage from './views/DataMgrPage/PublicDocMgrPage';
import SurveyGuideMgrPage from './views/DataMgrPage/SurveyGuideMgrPage';
import SurveyGuideEditPage from './views/DataMgrPage/SurveyGuideEditPage';
import InstructorMgrPage from './views/DataMgrPage/InstructorMgrPage';
import MakeInstructorPage from './views/DataMgrPage/MakeInstructorPage';
import AuditLogPage from './views/AuditLogPage/AuditLogPage';
import VideoUploadPage from './views/VideoPage/VideoUploadPage';
import VideoEditPage from './views/VideoPage/VideoEditPage';
import VideoMgrPage from './views/VideoPage/VideoMgrPage';
import VideoDeliveryMgrPage from './views/VideoPage/VideoDeliveryMgrPage';
import VideoDeliveryPage from './views/VideoPage/VideoDeliveryPage';
import VideoViewPage from './views/VideoPage/VideoList/VideoViewPage';
import TrialVideoViewPage from './views/VideoPage/TrialVideoViewPage';
import TrialAccountPage from './views/TrialAccountPage/TrialAccountPage';
import TrialProfilePage from './views/TrialAccountPage/TrialProfilePage';
import TrialUserMgrPage from './views/UserMgrPage/TrialUserMgrPage';
import TrialCampaignListPage from './views/DataMgrPage/TrialCampaignListPage';
import MakeTrialCampaignPage from './views/DataMgrPage/MakeTrialCampaignPage';
// 記事機能（Ph.3で追加）
import ArticleSeriesListPage from './views/ArticlePage/ArticleSeriesListPage';
// 記事機能（Ph.4で追加）
import ArticleUploadPage from './views/ArticlePage/ArticleUploadPage';
// 記事機能（Ph.5で追加）
import ArticleListPage from './views/ArticlePage/ArticleListPage';
// 記事機能（Ph.6で追加）
import ArticleDetailPage from './views/ArticlePage/ArticleDetailPage';
// 記事機能（Ph.6 編集機能で追加）
import ArticleEditPage from './views/ArticlePage/ArticleEditPage';

//null   Anyone Can go inside
//true   only logged in user can go inside
//false  logged in user can't go inside

// セッション失効の能動検知: ルート遷移時 + 60秒周期で失効を確認し、失効なら現在の
// ウィンドウでログインへ遷移させる（新しいタブは開かない）。Router 内部に配置する。
function SessionWatcher() {
  const location = useLocation();
  // ルート遷移のたびに失効チェック
  useEffect(() => {
    if (isSessionExpired()) redirectToLogin({ withAlert: true });
  }, [location]);
  // 60秒周期の定期チェック（操作せず放置した場合の失効も検知）
  useEffect(() => {
    const id = setInterval(() => {
      if (isSessionExpired()) redirectToLogin({ withAlert: true });
    }, 60000);
    return () => clearInterval(id);
  }, []);
  return null;
}

// トライアル（簡易ログイン）ユーザー専用のガード。Router 内部に配置する。
//   ① 簡易ログイン（メール未確認）セッションではパスワード変更画面へ入れない
//   ② 正式ログイン済みなのにプロフィール（氏名）が未入力なら /trial_profile へ誘導
// ※ トライアルユーザー以外（trial_campaign_key を持たないユーザー）には一切干渉しない。
const TRIAL_PROFILE_EXEMPT_PATHS = [
  '/trial_profile',
  '/trial_account',
  '/login',
  '/resetuser',
];

function TrialGuard() {
  const location = useLocation();
  const history = useHistory();
  const user = useSelector((state) => state.user);

  useEffect(() => {
    const userData = user && user.userData;
    // 認証情報の取得前・未ログインは何もしない
    if (!userData || userData.isAuth !== true) return;
    // トライアルユーザーでなければ何もしない
    if (!userData.trialCampaignKey) return;

    const pathname = location.pathname;

    // ① 簡易ログインセッションはパスワード変更不可
    if (userData.trialQuickLogin === true) {
      if (pathname === '/cp') {
        message.info(
          'メールでお送りしたログイン情報でログインしてから、パスワードを変更してください。'
        );
        history.replace('/');
      }
      return;
    }

    // ② 正式ログイン済みでプロフィール（氏名）が未入力ならプロフィール入力画面へ
    if (userData.trialProfileCompleted !== true) {
      const isExempt = TRIAL_PROFILE_EXEMPT_PATHS.some(
        (exemptPath) =>
          pathname === exemptPath || pathname.startsWith(exemptPath + '/')
      );
      // 現在の経路が対象外（無限リダイレクト防止）
      if (!isExempt) history.replace('/trial_profile');
    }
  }, [location, user, history]);

  return null;
}

function App() {
  const location = useLocation();
  // console.log(location.pathname);

  // 他ウィンドウ（PDF 401画面など）でlocalStorageがクリアされた時、
  // 本ウィンドウもログアウト状態に同期させる
  useEffect(() => {
    const handleStorage = (e) => {
      // 他ウィンドウで w_auth が削除された場合
      if (e.key === 'w_auth' && e.newValue === null) {
        if (!window.location.pathname.startsWith('/login')) {
          window.location.href = '/login';
        }
      }
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  // トライアルアカウント登録画面はヘッダー（NavBar）を非表示にする。
  // 登録時点では マイ・サーベイ / Home のボタンが不要なため。
  const isTrialAccount = location.pathname.startsWith('/trial_account');
  const hideNavBar = location.pathname.match('/videolist/video') || isTrialAccount;

  return (
    <Suspense fallback={<div>読み込み中...</div>}>
      <SessionWatcher />
      <TrialGuard />
      {hideNavBar ? '' : <NavBar />}
      {/* 固定ナビバーの高さぶん本文を下げる。
          フォント15px化（デザインシステム Ph.1）でナビバーが約78pxに高くなったため、
          旧 69px では本文上部が隠れる。余裕を見て 80px に調整。
          minHeight はナビバー(80px) + フッター(80px = Footer.js の固定高) の両方を差し引く。
          こうしないと「paddingTop 80 + minHeight(100vh-80) = 100vh」に Footer 80px が加わり、
          内容が短いページでも常時 80px の縦スクロールが出てコピーライトが見切れる。 */}
      <div
        style={{
          paddingTop: isTrialAccount ? '0px' : '80px',
          minHeight: 'calc(100vh - 160px)',
        }}
      >
        <Switch>
          <Route exact path="/" component={Auth(LandingPage, null)} />
          <Route exact path="/login" component={Auth(LoginPage, false)} />
          {/* 旧 個人登録画面（/register）は 2026-09 に廃止。古いリンク・ブックマークからの進入はログインへ誘導する */}
          <Redirect exact from="/register" to="/login" />
          <Route exact path="/trial_account" component={Auth(TrialAccountPage, null)} />
          <Route exact path="/trial_profile" component={Auth(TrialProfilePage, true)} />
          <Route exact path="/trialusermgr" component={Auth(TrialUserMgrPage, true, [9])} />
          <Route exact path="/trialcampaignlist" component={Auth(TrialCampaignListPage, true, [9])} />
          <Route exact path="/maketrialcampaign" component={Auth(MakeTrialCampaignPage, true, [9])} />
          <Route
            exact
            path="/resetuser"
            component={Auth(ResetUserPage, false)}
          />
          <Route
            exact
            path="/videolist/videoview/:t"
            component={VideoViewPage}
          />
          <Route exact path="/cp" component={Auth(CPPage, true)} />
          <Route exact path="/usermgr" component={Auth(UserMgrPage, true, [9])} />
          <Route
            exact
            path="/respondentmgr"
            component={Auth(RespondentMgrPage, true, [2, 9])}
          />
          <Route exact path="/e3depmgr" component={Auth(E3DepMgrPage, true, [2, 3, 9])} />
          <Route
            exact
            path="/status360"
            component={Auth(Status360Page, true, [2, 3, 7, 9])}
          />
          <Route
            exact
            path="/csvuserupload"
            component={Auth(CSVUserUploadPage, true, [9])}
          />
          <Route
            exact
            path="/exceluserupload"
            component={Auth(ExcelUserUploadPage, true, [2, 3, 9])}
          />
          <Route
            exact
            path="/csvusercheck"
            component={Auth(CSVUserCheckPage, true, [9])}
          />
          <Route
            exact
            path="/csvusermerge"
            component={Auth(CSVUserMergePage, true, [9])}
          />
          <Route
            exact
            path="/csvuserupdate"
            component={Auth(CSVUserUpdatePage, true, [9])}
          />
          <Route
            exact
            path="/csvuserupdateonly"
            component={Auth(CSVUserUpdateOnlyPage, true, [9])}
          />
          <Route
            exact
            path="/csvrelationupload"
            component={Auth(CSVRelationUploadPage, true, [9])}
          />
          <Route
            exact
            path="/csvtokeninsert"
            component={Auth(CSVTokenInsertPage, true, [9])}
          />
          <Route
            exact
            path="/csvdownload"
            component={Auth(CSVDownloadPage, true, [2, 9])}
          />
          <Route
            exact
            path="/pdfbatch"
            component={Auth(PdfBatchJobPage, true, [2, 3, 7, 9])}
          />
          <Route
            exact
            path="/download10010_company"
            component={Auth(PDF10010CompanyDownloadPage, true, [2, 9])}
          />
          {/* 従来の組織結果PDF画面。2026-10-26 の Web 画面リリースでメニューから外し、特権管理者だけに閉じた */}
          <Route
            exact
            path="/download30010"
            component={Auth(PDF30010DownloadPage, true, [9])}
          />
          {/* E³-Survey 組織結果（Web表示）。2026-10-26 本格リリース：組織結果を見られるロール全部（サーバー e3Access.js の WEB_OPEN_ROLES と同じ） */}
          <Route
            exact
            path="/results/30010/org"
            component={Auth(E3OrgResultPage, true, [2, 3, 7, 9])}
          />
          <Route
            exact
            path="/download70010"
            component={Auth(PDF70010DownloadPage, true, [2, 9])}
          />
          <Route
            exact
            path="/download80010"
            component={Auth(PDF80010DownloadPage, true, [2, 9])}
          />
          <Route
            exact
            path="/download40010_SS"
            component={Auth(PDF40010_SSDownloadPage, true, [2, 9])}
          />
          <Route
            exact
            path="/download60020_SS"
            component={Auth(PDF60020_SSDownloadPage, true, [2, 9])}
          />
          <Route
            exact
            path="/exceldownload30010"
            component={Auth(Excel30010DownloadPage, true, [2, 9])}
          />
          <Route
            exact
            path="/exceldownload10010"
            component={Auth(Excel10010DownloadPage, true, [2, 9])}
          />
          <Route
            exact
            path="/excelcomparedownload30010"
            component={Auth(Excel30010CompareDownloadPage, true, [2, 9])}
          />
          <Route
            exact
            path="/exceldownload60020"
            component={Auth(Excel60020DownloadPage, true, [2, 9])}
          />
          <Route
            exact
            path="/exceldownload40010"
            component={Auth(Excel40010DownloadPage, true, [2, 9])}
          />
          <Route
            exact
            path="/exceldownload50020"
            component={Auth(Excel50020DownloadPage, true, [2, 9])}
          />
          <Route
            exact
            path="/exceldownload50030"
            component={Auth(Excel50030DownloadPage, true, [2, 9])}
          />
          <Route
            exact
            path="/exceldownload50040"
            component={Auth(Excel50040DownloadPage, true, [2, 9])}
          />
          <Route
            exact
            path="/companysum30010"
            component={Auth(CompanySum30010Page, true, [2, 9])}
          />
          <Route
            exact
            path="/companysum50020"
            component={Auth(CompanySum50020Page, true, [2, 9])}
          />
          <Route
            exact
            path="/companysum50030"
            component={Auth(CompanySum50030Page, true, [9])}
          />
          <Route exact path="/corpmgr" component={Auth(CorpMgrPage, true, [3, 7])} />
          <Route exact path="/mysurvey" component={Auth(MySurveyPage, true)} />
          <Route
            exact
            path="/newtakesurvey"
            component={Auth(NewTakeSurveyPage, true)}
          />
          <Route
            exact
            path="/course90101"
            component={Auth(Course90101Page, true)}
          />
          <Route
            exact
            path="/course90105"
            component={Auth(Course90105Page, true)}
          />
          <Route
            exact
            path="/course90301"
            component={Auth(Course90301Page, true)}
          />
          <Route
            exact
            path="/course90501"
            component={Auth(Course90501Page, true)}
          />
          <Route
            exact
            path="/course90502"
            component={Auth(Course90502Page, true)}
          />
          <Route
            exact
            path="/csvupload"
            component={Auth(CSVUploadPage, true, [2, 9])}
          />
          <Route
            exact
            path="/makereport"
            component={Auth(MakeReportPage, true, [2, 9])}
          />
          <Route
            exact
            path="/questionmgr"
            component={Auth(QuestionMgrPage, true)}
          />
          <Route
            exact
            path="/questionsetmgr"
            component={Auth(QuestionSetMgrPage, true, [9])}
          />
          <Route
            exact
            path="/csvmailsend"
            component={Auth(CSVMailSendPage, true, [9])}
          />
          <Route
            exact
            path="/csvmailsendreservate"
            component={Auth(CSVMailSendReservatePage, true, [9])}
          />
          <Route
            exact
            path="/surveymailsend"
            component={Auth(SurveyMailSendPage, true, [9])}
          />
          <Route
            exact
            path="/mailsendreservate"
            component={Auth(MailSendReservatePage, true, [9])}
          />
          <Route
            exact
            path="/mailreservatelist"
            component={Auth(MailReservateListPage, true, [9])}
          />
          <Route
            exact
            path="/multimailsendreservate"
            component={Auth(MultiMailSendReservatePage, true, [9])}
          />
          <Route
            exact
            path="/mailtemplate"
            component={Auth(MailTemplatePage, true, [2, 9])}
          />
          <Route
            exact
            path="/maketemplate"
            component={Auth(MakeTemplatePage, true, [2, 9])}
          />
          <Route
            exact
            path="/grouplist"
            component={Auth(GroupListPage, true, [9])}
          />
          <Route
            exact
            path="/orgmgr"
            component={Auth(OrgMgrPage, true, [2, 3, 9])}
          />
          <Route
            exact
            path="/makegroup"
            component={Auth(MakeGroupPage, true, [9])}
          />
          <Route
            exact
            path="/makeseason"
            component={Auth(MakeSeasonPage, true, [9])}
          />
          <Route
            exact
            path="/seasonlist"
            component={Auth(SeasonListPage, true, [9])}
          />
          <Route exact path="/makeqset" component={Auth(MakeQSetPage, true, [9])} />
          <Route
            exact
            path="/editqset/:id"
            component={Auth(EditQSetPage, true, [9])}
          />
          <Route
            exact
            path="/publicdocmgr"
            component={Auth(PublicDocMgrPage, true, [2, 9])}
          />
          <Route
            exact
            path="/surveyguidemgr"
            component={Auth(SurveyGuideMgrPage, true, [9])}
          />
          <Route
            exact
            path="/surveyguide/new"
            component={Auth(SurveyGuideEditPage, true, [9])}
          />
          <Route
            exact
            path="/surveyguide/:guideId/edit"
            component={Auth(SurveyGuideEditPage, true, [9])}
          />
          <Route
            exact
            path="/instructormgr"
            component={Auth(InstructorMgrPage, true, [9])}
          />
          <Route
            exact
            path="/makeinstructor"
            component={Auth(MakeInstructorPage, true, [9])}
          />
          {/* 操作ログ（監査ログ）閲覧 — 「操作ログ保存」PJ Ph.3・role 9 限定 */}
          <Route
            exact
            path="/auditlog"
            component={Auth(AuditLogPage, true, [9])}
          />
          <Route
            exact
            path="/videoupload"
            component={Auth(VideoUploadPage, true, [2, 9])}
          />
          <Route
            exact
            path="/videoedit"
            component={Auth(VideoEditPage, true, [2, 9])}
          />
          <Route exact path="/videomgr" component={Auth(VideoMgrPage, true, [2, 9])} />
          <Route
            exact
            path="/videodelivery"
            component={Auth(VideoDeliveryPage, true)}
          />
          <Route
            exact
            path="/videodeliverymgr"
            component={Auth(VideoDeliveryMgrPage, true, [2, 9])}
          />
          {/* 記事機能（Ph.3で追加） */}
          <Route
            exact
            path="/articleseries"
            component={Auth(ArticleSeriesListPage, true, [9])}
          />
          {/* 記事機能（Ph.4で追加） */}
          <Route
            exact
            path="/articleupload"
            component={Auth(ArticleUploadPage, true, [9])}
          />
          {/* 記事機能（Ph.5で追加） */}
          {/* 記事トップ（/article）はシリーズ一覧（ArticleSeriesListPage）= 閲覧者+管理者共用 */}
          <Route
            exact
            path="/article"
            component={Auth(ArticleSeriesListPage, true, [2, 9])}
          />
          <Route
            exact
            path="/article/:seriesCode"
            component={Auth(ArticleListPage, true, [2, 9])}
          />
          {/* 記事機能（Ph.6で追加） */}
          <Route
            exact
            path="/article/:seriesCode/:articleId"
            component={Auth(ArticleDetailPage, true, [2, 9])}
          />
          {/* 記事機能（Ph.6 編集機能、role 9 専用） */}
          <Route
            exact
            path="/article/:seriesCode/:articleId/edit"
            component={Auth(ArticleEditPage, true, [9])}
          />
          <Route
            exact
            path="/trialvideoview"
            component={Auth(TrialVideoViewPage, true)}
          />
          <Route
            exact
            path="/chatgpttest"
            component={Auth(ChatGptTestPage, true)}
          />
        </Switch>
      </div>
      <Footer />
    </Suspense>
  );
}

export default App;
